import { grey } from "@mui/material/colors";


declare module '@mui/material/styles' {
    interface Palette {
        greyScale: Palette['primary'];
        neutral: Palette['primary'];
    }
    interface PaletteOptions {
        greyScale?: PaletteOptions['primary'];
        neutral?: PaletteOptions['primary'];
    }
}
export const defaultPalette = {
    primary: {
        main: '#003448', 
        light: '#335D6D',
        dark: '#002432',
        contrastText: '#fff',
    },
    secondary: {
        main: '#413881',
        light: '#A29BD4',
        dark: '#1B1449',
        contrastText: '#fff',
    },
    error: {
        main: '#C73153',
        light: '#D25A75',
        dark: '#8B223A',
        contrastText: '#fff',
    },
    success: {
        main: '#65AA9A',
        light: '#84BBAE',
        dark: '#47776C',
        contrastText: '#003448',
    },
    warning: {
        main: '#FFAB10',
        light: '#FFBC40',
        dark: '#B2780B',
        contrastText: '#1E1E1E',
    },
    greyScale: {
        main: grey[400],
        light: grey[100],
        dark: grey[600],
        contrastText: grey[800],
    },
    neutral: {
        main: '#E0E0E0',
        light: '#F5F5F5',
        dark: '#BDBDBD',
        contrastText: '#212121',
    },


}